var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Accordion, AccordionSet, Button, Checkbox, Col, ErrorModal, Modal, Pane, PaneFooter, Row, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation, useQuery } from "react-query";
import { RecekSelect, RecekSelection, RecekTextArea, } from "../../components/inputs";
import { fetchPublisherPrefixes, fetchPublisherPrefixById, resolvePublisherPrefix, } from "../../api/publisherPrefixService";
import { fetchAllAgencyPrefixes } from "../../api/agencyPrefixesService";
import { blockProductNumberRange } from "../../api/productNumberService";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useAccordion } from "../../utils/useAccordion";
import { useModal } from "../../utils/useModal";
import { formatPublisherPrefixLabel } from "../../utils/publisherPrefixUtils";
import { calculateEAN13CheckDigit } from "../../utils/ean13Utils";
import { ProductNumberBlockRangeRequestBlockReasonEnum, } from "../../types/Api";
import styles from "./ProductNumberBlockRange.module.css";
var calculateCheckDigit = function (first12) {
    try {
        return calculateEAN13CheckDigit(first12);
    }
    catch (_a) {
        return "?";
    }
};
var emptyParts = {
    intl: "",
    agency: "",
    publisher: "",
    seq: "",
};
var getFullNumber = function (p) {
    return p.intl + p.agency + p.publisher + p.seq;
};
export var ProductNumberBlockRange = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _l = useAccordion({ general: true }), accordionStatus = _l.accordionStatus, toggleAccordion = _l.toggleAccordion;
    var _m = useModal(), isErrorOpen = _m.isOpen, errorMessage = _m.message, openErrorModal = _m.openModal, closeErrorModal = _m.closeModal;
    var _o = useState(false), usePrefixSelection = _o[0], setUsePrefixSelection = _o[1];
    var _p = useState(""), selectedAgencyPrefixId = _p[0], setSelectedAgencyPrefixId = _p[1];
    var _q = useState(""), searchQuery = _q[0], setSearchQuery = _q[1];
    var _r = useState(""), selectedPublisherPrefixId = _r[0], setSelectedPublisherPrefixId = _r[1];
    var _s = useState(__assign({}, emptyParts)), fromParts = _s[0], setFromParts = _s[1];
    var _t = useState(__assign({}, emptyParts)), toParts = _t[0], setToParts = _t[1];
    var _u = useState(""), blockReason = _u[0], setBlockReason = _u[1];
    var _v = useState(""), blockComment = _v[0], setBlockComment = _v[1];
    var _w = useState(null), result = _w[0], setResult = _w[1];
    var agencyPrefixesData = useQuery(["agency-prefixes-block-range"], function () { return fetchAllAgencyPrefixes(ky); }, { enabled: usePrefixSelection }).data;
    var agencyPrefixes = useMemo(function () { var _a; return (_a = agencyPrefixesData === null || agencyPrefixesData === void 0 ? void 0 : agencyPrefixesData.items) !== null && _a !== void 0 ? _a : []; }, [agencyPrefixesData]);
    var selectedPrefixData = useQuery(["publisher-prefix-block-selected", selectedPublisherPrefixId], function () { return fetchPublisherPrefixById(ky, selectedPublisherPrefixId); }, {
        enabled: !!selectedPublisherPrefixId,
        staleTime: 5 * 60 * 1000,
    }).data;
    var _x = useQuery(["publisher-prefixes-block-search", searchQuery], function () {
        var cqlQuery = searchQuery.trim()
            ? "value=*".concat(searchQuery, "* or publisher.name=*").concat(searchQuery, "*")
            : "cql.allRecords=1";
        return fetchPublisherPrefixes(ky, { query: cqlQuery, limit: 50 });
    }, {
        enabled: usePrefixSelection && !!selectedAgencyPrefixId && !!searchQuery.trim(),
        staleTime: 30000,
    }), searchResultsData = _x.data, isLoadingSearch = _x.isLoading;
    var publisherPrefixOptions = useMemo(function () {
        var options = [];
        if (selectedPrefixData && selectedPublisherPrefixId) {
            options.push({
                value: selectedPrefixData.id || "",
                label: formatPublisherPrefixLabel(selectedPrefixData),
            });
        }
        var searchResults = (searchResultsData === null || searchResultsData === void 0 ? void 0 : searchResultsData.items) || [];
        searchResults
            .filter(function (prefix) {
            var _a, _b;
            return prefix.id !== selectedPublisherPrefixId &&
                ((_b = (_a = prefix.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.agencyPrefix) === null || _b === void 0 ? void 0 : _b.id) ===
                    selectedAgencyPrefixId;
        })
            .forEach(function (prefix) {
            options.push({
                value: prefix.id || "",
                label: formatPublisherPrefixLabel(prefix),
            });
        });
        return options;
    }, [
        selectedPrefixData,
        selectedPublisherPrefixId,
        searchResultsData,
        selectedAgencyPrefixId,
    ]);
    var intlValue = (_d = (_c = (_b = (_a = selectedPrefixData === null || selectedPrefixData === void 0 ? void 0 : selectedPrefixData.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.agencyPrefix) === null || _b === void 0 ? void 0 : _b.internationalPrefix) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "";
    var agencyValue = (_g = (_f = (_e = selectedPrefixData === null || selectedPrefixData === void 0 ? void 0 : selectedPrefixData.publisherPrefixRange) === null || _e === void 0 ? void 0 : _e.agencyPrefix) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : "";
    var publisherValue = (_h = selectedPrefixData === null || selectedPrefixData === void 0 ? void 0 : selectedPrefixData.value) !== null && _h !== void 0 ? _h : "";
    var magnitude = (_k = (_j = selectedPrefixData === null || selectedPrefixData === void 0 ? void 0 : selectedPrefixData.publisherPrefixRange) === null || _j === void 0 ? void 0 : _j.magnitude) !== null && _k !== void 0 ? _k : 0;
    var maxSequence = magnitude > 0 ? Math.pow(10, magnitude) - 1 : 0;
    var fromFull = usePrefixSelection
        ? intlValue + agencyValue + publisherValue + fromParts.seq
        : getFullNumber(fromParts);
    var toFull = usePrefixSelection
        ? intlValue + agencyValue + publisherValue + toParts.seq
        : getFullNumber(toParts);
    var fromCheckDigit = calculateCheckDigit(fromFull);
    var toCheckDigit = calculateCheckDigit(toFull);
    var fromSeq = fromParts.seq ? parseInt(fromParts.seq, 10) : NaN;
    var toSeq = toParts.seq ? parseInt(toParts.seq, 10) : NaN;
    var blockCount = usePrefixSelection
        ? !isNaN(fromSeq) && !isNaN(toSeq) && toSeq >= fromSeq
            ? toSeq - fromSeq + 1
            : 0
        : fromFull.length === 12 &&
            toFull.length === 12 &&
            parseInt(toFull, 10) >= parseInt(fromFull, 10)
            ? parseInt(toFull, 10) - parseInt(fromFull, 10) + 1
            : 0;
    var handlePrefixToggle = function () {
        if (usePrefixSelection) {
            setSelectedAgencyPrefixId("");
            setSelectedPublisherPrefixId("");
            setSearchQuery("");
        }
        setFromParts(__assign({}, emptyParts));
        setToParts(__assign({}, emptyParts));
        setUsePrefixSelection(!usePrefixSelection);
    };
    var handleAgencyPrefixChange = function (e) {
        setSelectedAgencyPrefixId(e.target.value);
        setSelectedPublisherPrefixId("");
        setSearchQuery("");
        setFromParts(__assign({}, emptyParts));
        setToParts(__assign({}, emptyParts));
    };
    var handlePublisherPrefixChange = function (newId) {
        setSelectedPublisherPrefixId(newId);
        setFromParts(__assign({}, emptyParts));
        setToParts(__assign({}, emptyParts));
    };
    var handleSearchInput = function (inputValue) {
        setSearchQuery(inputValue);
    };
    var updatePart = function (setter, field, value) {
        var digits = value.replace(/\D/g, "");
        setter(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = digits, _a)));
        });
    };
    var blockRangeMutation = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        var resolved, publisherPrefixId, resolvedIntl, resolvedAgency, resolvedPublisher, resolvedPrefix, resolvedMagnitude, expectedLen, fFrom, fTo;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (usePrefixSelection) {
                        return [2 /*return*/, blockProductNumberRange(ky, {
                                publisherPrefixId: selectedPublisherPrefixId,
                                fromSequence: fromSeq,
                                toSequence: toSeq,
                                blockReason: blockReason,
                                blockComment: blockComment || undefined,
                            })];
                    }
                    return [4 /*yield*/, resolvePublisherPrefix(ky, fromFull)];
                case 1:
                    resolved = _l.sent();
                    publisherPrefixId = resolved.id || "";
                    resolvedIntl = (_d = (_c = (_b = (_a = resolved.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.agencyPrefix) === null || _b === void 0 ? void 0 : _b.internationalPrefix) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "";
                    resolvedAgency = (_g = (_f = (_e = resolved.publisherPrefixRange) === null || _e === void 0 ? void 0 : _e.agencyPrefix) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : "";
                    resolvedPublisher = (_h = resolved.value) !== null && _h !== void 0 ? _h : "";
                    resolvedPrefix = resolvedIntl + resolvedAgency + resolvedPublisher;
                    resolvedMagnitude = (_k = (_j = resolved.publisherPrefixRange) === null || _j === void 0 ? void 0 : _j.magnitude) !== null && _k !== void 0 ? _k : 0;
                    expectedLen = resolvedPrefix.length + resolvedMagnitude;
                    if (fromFull.length !== expectedLen ||
                        toFull.length !== expectedLen ||
                        !fromFull.startsWith(resolvedPrefix) ||
                        !toFull.startsWith(resolvedPrefix)) {
                        throw new Error("Product numbers do not match the same publisher prefix");
                    }
                    fFrom = parseInt(fromFull.slice(resolvedPrefix.length), 10);
                    fTo = parseInt(toFull.slice(resolvedPrefix.length), 10);
                    return [2 /*return*/, blockProductNumberRange(ky, {
                            publisherPrefixId: publisherPrefixId,
                            fromSequence: fFrom,
                            toSequence: fTo,
                            blockReason: blockReason,
                            blockComment: blockComment || undefined,
                        })];
            }
        });
    }); }, {
        onSuccess: function (data) {
            setResult(data);
        },
        onError: function () {
            openErrorModal(formatMessage({ id: "ui-br-agency.product-number.blockRange.error" }));
        },
    });
    var canSubmitPrefixMode = selectedPublisherPrefixId &&
        blockReason &&
        !isNaN(fromSeq) &&
        !isNaN(toSeq) &&
        toSeq >= fromSeq &&
        fromSeq >= 0 &&
        toSeq <= maxSequence;
    var canSubmitFreeMode = blockReason &&
        fromFull.length === 12 &&
        toFull.length === 12 &&
        parseInt(toFull, 10) >= parseInt(fromFull, 10);
    var canSubmit = usePrefixSelection
        ? canSubmitPrefixMode
        : canSubmitFreeMode;
    var handleSubmit = function () {
        if (!canSubmit)
            return;
        blockRangeMutation.mutate();
    };
    var renderNumberRow = function (labelId, parts, setter, checkDigit, prefixReadOnly) {
        var totalDigits = prefixReadOnly
            ? (intlValue + agencyValue + publisherValue + parts.seq).length
            : getFullNumber(parts).length;
        var isOverLimit = totalDigits > 12;
        var inputClass = isOverLimit ? styles.seqInputError : styles.seqInput;
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.fieldLabel },
                React.createElement(FormattedMessage, { id: labelId })),
            React.createElement("div", { className: styles.structuredNumber },
                prefixReadOnly ? (React.createElement("span", { className: styles.prefixSegment }, intlValue)) : (React.createElement("input", { type: "text", className: inputClass, value: parts.intl, onChange: function (e) { return updatePart(setter, "intl", e.target.value); }, placeholder: "978", style: { width: "".concat(Math.max(5, parts.intl.length + 2) * 12, "px") } })),
                React.createElement("span", { className: styles.dash }, "-"),
                prefixReadOnly ? (React.createElement("span", { className: styles.prefixSegment }, agencyValue)) : (React.createElement("input", { type: "text", className: inputClass, value: parts.agency, onChange: function (e) { return updatePart(setter, "agency", e.target.value); }, placeholder: "80", style: {
                        width: "".concat(Math.max(3, parts.agency.length + 1) * 12, "px"),
                    } })),
                React.createElement("span", { className: styles.dash }, "-"),
                prefixReadOnly ? (React.createElement("span", { className: styles.prefixSegment }, publisherValue)) : (React.createElement("input", { type: "text", className: inputClass, value: parts.publisher, onChange: function (e) { return updatePart(setter, "publisher", e.target.value); }, placeholder: "00000", style: {
                        width: "".concat(Math.max(5, parts.publisher.length + 1) * 12, "px"),
                    } })),
                React.createElement("span", { className: styles.dash }, "-"),
                React.createElement("input", { type: "text", className: inputClass, value: parts.seq, onChange: function (e) { return updatePart(setter, "seq", e.target.value); }, placeholder: prefixReadOnly ? "0".repeat(magnitude || 2) : "00", style: {
                        width: "".concat(Math.max(3, prefixReadOnly ? magnitude : parts.seq.length + 1) * 12, "px"),
                    }, disabled: prefixReadOnly && !selectedPublisherPrefixId }),
                React.createElement("span", { className: styles.dash }, "-"),
                React.createElement("span", { className: styles.checkDigit }, checkDigit)),
            isOverLimit && (React.createElement("div", { className: styles.lengthWarning },
                React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.blockRange.warning.tooLong", values: { current: totalDigits, max: 12 } })))));
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.product-number.blockRange.pane.title",
            }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !canSubmit || blockRangeMutation.isLoading },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.push("/bragency/product-numbers"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }) },
            React.createElement(AccordionSet, null,
                React.createElement(Accordion, { label: formatMessage({
                        id: "ui-br-agency.product-number.blockRange.pane.title",
                    }), open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement(Checkbox, { label: formatMessage({
                                    id: "ui-br-agency.product-number.blockRange.usePrefixSelection",
                                }), checked: usePrefixSelection, onChange: handlePrefixToggle }))),
                    usePrefixSelection && (React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 3 },
                            React.createElement(RecekSelect, { labelId: "ui-br-agency.product-number.blockRange.field.label.agencyPrefix", value: selectedAgencyPrefixId, onChange: handleAgencyPrefixChange },
                                React.createElement("option", { value: "" }, formatMessage({
                                    id: "ui-br-agency.product-number.blockRange.field.placeholder.agencyPrefix",
                                })),
                                agencyPrefixes
                                    .filter(function (option) { return option != null; })
                                    .map(function (option) {
                                    var _a, _b, _c;
                                    return (React.createElement("option", { key: option.id, value: option.id }, (_b = (_a = option.internationalPrefix) === null || _a === void 0 ? void 0 : _a.agency) !== null && _b !== void 0 ? _b : "N/A",
                                        " ", (_c = option.internationalPrefix) === null || _c === void 0 ? void 0 :
                                        _c.value,
                                        "-",
                                        option.value));
                                }))),
                        React.createElement(Col, { xs: 12, md: 3 },
                            React.createElement(RecekSelection, { labelId: "ui-br-agency.product-number.blockRange.publisherPrefix", asyncFilter: true, value: selectedPublisherPrefixId, loading: isLoadingSearch, onFilter: handleSearchInput, onChange: handlePublisherPrefixChange, dataOptions: publisherPrefixOptions, placeholder: formatMessage({
                                    id: "ui-br-agency.product-number.blockRange.field.placeholder.publisherPrefix",
                                }), disabled: !selectedAgencyPrefixId })))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 6 }, renderNumberRow("ui-br-agency.product-number.blockRange.fromNumber", fromParts, setFromParts, fromCheckDigit, usePrefixSelection))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 6 }, renderNumberRow("ui-br-agency.product-number.blockRange.toNumber", toParts, setToParts, toCheckDigit, usePrefixSelection))),
                    blockCount > 0 && (React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 6 },
                            React.createElement("div", { className: styles.rangeCount },
                                React.createElement("strong", null, blockCount),
                                " ",
                                React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.blockRange.count" }),
                                usePrefixSelection && maxSequence > 0 && (React.createElement("span", null,
                                    " ",
                                    "(",
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.blockRange.rangeHint", values: { max: maxSequence } }),
                                    ")")),
                                React.createElement("div", null,
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.blockRange.assignedSkippedHint" })))))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 6 },
                            React.createElement(RecekSelect, { labelId: "ui-br-agency.product-number.field.label.blockReason", value: blockReason, onChange: function (e) {
                                    return setBlockReason(e.target.value);
                                }, required: true },
                                React.createElement("option", { value: "" }, formatMessage({
                                    id: "ui-br-agency.product-number.field.placeholder.blockReason",
                                })),
                                React.createElement("option", { value: ProductNumberBlockRangeRequestBlockReasonEnum.UNAUTHORIZED_USE }, formatMessage({
                                    id: "ui-br-agency.product-number.blockReason.unauthorizedUse",
                                })),
                                React.createElement("option", { value: ProductNumberBlockRangeRequestBlockReasonEnum.PRESUMED_PUBLISHED }, formatMessage({
                                    id: "ui-br-agency.product-number.blockReason.presumedPublished",
                                }))))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 6 },
                            React.createElement(RecekTextArea, { labelId: "ui-br-agency.product-number.field.label.blockComment", value: blockComment, onChange: function (e) {
                                    return setBlockComment(e.target.value);
                                } })))))),
        React.createElement(Modal, { open: result !== null, label: formatMessage({
                id: "ui-br-agency.product-number.blockRange.modal.title",
            }), footer: React.createElement(Button, { buttonStyle: "primary", onClick: function () { return history.push("/bragency/product-numbers"); } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.close" })) }, result && (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.blockRange.success", values: {
                    blocked: result.blockedCount,
                    alreadyBlocked: result.alreadyBlockedCount,
                    created: result.createdCount,
                    skippedAssigned: result.skippedAssignedCount,
                } })))),
        React.createElement(ErrorModal, { open: isErrorOpen, label: formatMessage({
                id: "ui-br-agency.product-number.blockRange.modal.title",
            }), content: errorMessage, onClose: closeErrorModal })));
};
